<alliance-feature-header *ngIf="state.isShowHeader" [positionMode]="state.headerData?.positionMode || null">
  <!-- centerContent -->
  <ng-template #centerContent>
    <alliance-clubs-header></alliance-clubs-header>
  </ng-template>

  <!-- bottomContent -->
  <ng-template #botContent>
    <ng-container [cdkPortalOutlet]="state.bottomContent"></ng-container>
  </ng-template>
</alliance-feature-header>
